import { render, staticRenderFns } from "./ChooseTemplateSelect.vue?vue&type=template&id=25d4466a"
import script from "./ChooseTemplateSelect.vue?vue&type=script&lang=js"
export * from "./ChooseTemplateSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports